import DeviceFamilyEnhanced from '../components/DeviceFamilyEnhanced';

export const DevicesFamiliesManagement = () => {
  return <DeviceFamilyEnhanced />;
};